import React, { useEffect, useState} from "react";
import { Link } from 'react-router-dom';
import './home.css';
import ProjectenGrid from '../componenten/projectenGrid/projectenGrid';
import OverOns from './componenten/overons.jpg';
import Koffie from './componenten/koffie.jpg';
import HomeHeader from './componenten/HomeHeader.jpg';
import LogoLicht from './componenten/Mindis-Logo-Licht.png';
import PartnerGrid from "../componenten/partners/partners";

function Home() {
    console.log("Schermbreedte op Home:", window.innerWidth);

    const [hovering0, setHovering0] = useState(true);
    const [hovering1, setHovering1] = useState(false);
    const [hovering2, setHovering2] = useState(false);
    const [hovering3, setHovering3] = useState(false);

    return (
        <div className="home">
            <section className="HP-heading">
                <img src={HomeHeader} alt='Home Foto' className='HomeHeader' />
                <div className='headingoverlay'>
                    <img src={LogoLicht} alt='Mindis Logo' className='MindisLogo' />
                </div>
            </section>

            <section className="Mindis">
                <div id="Mindistxt" className="Mindistxt">
                    <h2>OVER MINDIS</h2>
                    <p><b>Bij Mindis maken we ideeën. </b>Dat is vaak het eerste wat we zeggen als we een ruimte binnenstappen. We helpen mensen met een praktisch en laagdrempelige aanpak ideeën concreet te maken.</p>
                    <p>Geen saaie gesprekken met lange rapporten als eindresultaat, maar co-creatie sessies die iets opleveren: een 3D-print, een schets, een video of een technisch prototype. Iets dat je kunt laten zien. Voelen. En vooral: <b>uitproberen</b>.</p>
                    <p><b>Praktisch uitproberen staat centraal bij Mindis.</b> Of het nu gaat om het aftasten of een vraag leeft bij je doelgroep, om te voelen welk idee je team het meest aanspreekt, of om te zien welk prototype de meeste impact maakt— wij zorgen voor een proefopstelling op locatie zodat je weet waar je aan toe bent.</p>
                    <p>Klinkt goed? Laten we er iets moois van maken!</p>
                </div>
                <div className="MindisPic">
                <img src={OverOns} alt="Over Ons" className="Picture-OverOns" />
                </div>
            </section>

            <div className='USP'>
                <div className="usp-buttons">

                    <div 
                    className="but1"
                    onMouseEnter={() => {
                        setHovering1(true);
                        setHovering0(false)
                    }}
                    onMouseLeave={() => {
                        setHovering1(false);
                        setHovering0(true)
                    }}
                    >
                        <p><b>Onderzoeken</b></p>
                    </div>

                    <div 
                    className="but2"
                    onMouseEnter={() => {
                        setHovering2(true);
                        setHovering0(false)
                    }}
                    onMouseLeave={() => {
                        setHovering2(false);
                        setHovering0(true)
                    }}
                    >
                        <p><b>Tekenen</b></p>
                    </div>

                    <div 
                    className="but3"
                    onMouseEnter={() => {
                        setHovering3(true);
                        setHovering0(false)
                    }}
                    onMouseLeave={() => {
                        setHovering3(false);
                        setHovering0(true)
                    }}
                    >
                        <p><b>Maken</b></p></div>
                </div>
                
                {hovering0 && (
                <div className="usp-tekst">
                    <div className="usp-tekst1">
                    <p><b>
                        Hoe meer je leest over digitale innovaties, hoe lastiger het vaak wordt om het écht te snappen.
                    </b></p>
                    <p>
                        Overal duiken vage termen en dure woorden op. Maar wat betekent dat nou concreet voor jouw uitdaging?
                    </p>
                    <p>
                        Bij Mindis houden we het graag helder. Geen vakjargon, maar duidelijke taal.
                    </p>
                    <p>
                        Want of het nu gaat om een app, sensor of prototype, uiteindelijk draait het om drie dingen: onderzoeken, testen en maken.
                    </p>
                    <p><b>
                        Zweef met je muis over één van de knoppen en ontdek hoe wij dat aanpakken.
                    </b></p>
                    </div>
                    <div className="usp-foto1">

                    </div>
                </div>
                )}

                {hovering1 && (
                <div className="usp-tekst">
                    <p>WIJ DOEN DUS AAN ONDERZOEKEN</p>
                </div>
                )}

                {hovering2 && (
                <div className="usp-tekst">
                    <p>WOW WIJ DOEN HIER OOK AAN TEKENEN</p>
                </div>
                )}

                {hovering3 && (
                <div className="usp-tekst">
                    <p>ZIEK, WE DOEN OOK GEWOON AAN MAKEN</p>
                </div>
                )}
                
            </div>

            <section id="Projecten" className="ProjectenSection">
                <h2>PROJECTEN</h2>
                <ProjectenGrid enkelerij={true} animate={true} lightmode={false}/>
                <a href='./projecten' className='ProjectLink'>Bekijk hier al onze projcten</a>
            </section>

            <div className='USP'>
                <p><b>Klantgericht</b></p>
                <p><b>Praktisch</b></p>
                <p><b>Nuchter</b></p>
            </div>

            <section id="Meeting" className="Meeting">
                <div className="KoffiePic">
                    <img src={Koffie} alt="Picture Coffee" className="PictureKoffie" />
                </div>
                <div className="Koffietxt">
                    <div>
                        <h2>Laten we verder praten!</h2>
                        <p>Wil je meer te weten komen over Mindis? Stuur ons dan even een berichtje. Dan komen wij gewoon langs.</p>
                        <p>Zet jij de koffie vast klaar?</p>
                    </div>
                    <a href='./contact' className="ContactLink">Kom in contact met Mindis!</a>
                </div>
            </section>
        </div>
    );
}

export default Home;